module.exports = __webpack_public_path__ + "img/beefeater-age-confirm-logo.300d4b53.svg";